// @ts-check
import React from "react"
import Button from "../../../../../components/atoms/Button.atom"
import ContentLayoutHeader from "../../../../../components/layouts/ContentLayoutHeader.layout"
import { clsx } from "../../../../../utils/strings.utils"

/**
 * @typedef {object} HeaderProps
 * @property {string} title
 * @property {string} [subtitle]
 * @property {boolean} [subtitleLoading]
 * @property {() => void} [onOpenHistory]
 * @property {() => void} [onEditSubtitle]
 * @property {boolean} [canEditSubtitle]
 * @property {string} [className]
 */

/**
 * @param {HeaderProps} props
 */
export default function Header({
  title,
  subtitle,
  subtitleLoading,
  onOpenHistory,
  onEditSubtitle,
  canEditSubtitle,
  className,
}) {
  const historyButton = (
    <Button
      type="button"
      icon="pi pi-history"
      className="p-button-rounded p-button-text"
      onClick={onOpenHistory ?? (() => {})}
      aria-label="Historial"
    />
  )

  const subtitleAccessory =
    canEditSubtitle && subtitle ?
      <Button
        type="button"
        icon="pi pi-pencil"
        className="p-button-rounded p-button-text p-button-sm p-button-icon-only estimation-agent-quick-v3__title-edit-button"
        onClick={onEditSubtitle ?? (() => {})}
        aria-label="Editar título del chat"
      />
    : null

  return (
    <div className={clsx("estimation-agent-quick-v3__header", className)}>
      <ContentLayoutHeader
        title={title}
        subtitle={subtitle}
        subtitleLoading={subtitleLoading}
        subtitleAccessory={subtitleAccessory}
        extraContent={historyButton}
      />
    </div>
  )
}
